/**
 * PrintInstitutionalFrame — composant DRY pour les en-têtes/pieds de page
 * institutionnels imprimables (charte COPPAM unifiée).
 *
 * Usage :
 *   import PrintInstitutionalFrame from '../components/PrintInstitutionalFrame';
 *   import '../styles/print-institutional.css';
 *
 *   return (
 *     <div data-print-mode="institutional">
 *       <PrintInstitutionalFrame docTitle="Rapport Admin" />
 *       <div className="print-area">...contenu...</div>
 *     </div>
 *   );
 *
 * Le composant gère seul :
 *   - logo COPPAM HD
 *   - filet doré
 *   - décodage JWT pour récupérer l'email de l'admin connecté
 *   - signature numérique (email + timestamp UTC + empreinte session)
 *   - pagination CSS via counter(page) / counter(pages)
 */
import React from 'react';

const COPPAM_LOGO_URL = "https://customer-assets.emergentagent.com/job_8110032b-6f65-4eb8-8d34-03bf75c7208f/artifacts/eryt4nxb_COPPAM_Garanties_Solidaires_HD_transparent%20RECADREE.png";

const getEmailFromJWT = () => {
  try {
    const tok = localStorage.getItem('access_token') || localStorage.getItem('token') || '';
    const part = tok.split('.')[1];
    if (!part) return '';
    const p = JSON.parse(atob(part.replace(/-/g, '+').replace(/_/g, '/')));
    return p.email || p.sub || '';
  } catch { return ''; }
};

const getSessionFingerprint = () => {
  try { return (localStorage.getItem('access_token') || localStorage.getItem('token') || '').slice(-12).toUpperCase() || '—'; }
  catch { return '—'; }
};

const PrintInstitutionalFrame = ({
  docTitle = 'Rapport institutionnel',
  caption = 'Centre de contrôle',
  captionSecondary = 'Administrateur',
}) => {
  const email = getEmailFromJWT();
  const dateFr = new Date().toLocaleDateString('fr-FR', { day: '2-digit', month: 'long', year: 'numeric' });
  const timeFr = new Date().toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  const isoUtc = new Date().toISOString().replace('T', ' ').slice(0, 19);
  const fp = getSessionFingerprint();
  const roleLabel = email ? `Émis par ${email}` : 'Administrateur COPPAM';

  return (
    <>
      <header className="print-institutional-header">
        <div className="pih-left">
          <img src={COPPAM_LOGO_URL} alt="COPPAM - Garanties Solidaires" className="pih-logo" />
          <div className="pih-caption">
            <div className="pih-meta">
              {caption}<span className="pih-sep">•</span>{captionSecondary}
            </div>
          </div>
        </div>
        <div className="pih-right">
          <div className="pih-doc-title">{docTitle}</div>
          <div>{email}</div>
          <div>{dateFr} - {timeFr}</div>
        </div>
      </header>
      <footer className="print-institutional-footer">
        <div className="pif-signature">
          <span className="pif-line"><span className="pif-label">Document généré par</span></span>
          <span className="pif-line"><span className="pif-value">{roleLabel} le {isoUtc} UTC</span></span>
          <span className="pif-line"><span className="pif-value">Empreinte session : {fp}</span></span>
        </div>
        <div className="pif-pages" />
      </footer>
    </>
  );
};

export default PrintInstitutionalFrame;
